import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, Drawer } from "@/ui-kit";
import { Form } from "@/components/controls";
import { FormProvider } from "react-hook-form";
import { HudForm, useHudForm } from "@/components/profile-forms/HudForm";
import type { IInspectorHud } from "@/types/users-inspectors";

type IProps = {
  userId: number;
  hudDetail: IInspectorHud;
  onSave: (v: IInspectorHud) => void;
  onDismiss: () => void;
};

const EditModal = ({ userId, hudDetail, onSave, onDismiss }: IProps) => {
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (response: IInspectorHud) => {
      onSave(response);
      onDismiss();
    },
    [onSave, onDismiss],
  );

  const { form, onSubmit, loading } = useHudForm({
    userId,
    hudDetail,
    onSuccess: handleSuccess,
  });

  return (
    <FormProvider {...form}>
      <Drawer
        className="settings__user-modal"
        title={t("label.hud_details")}
        open={true}
        onOpenChange={onDismiss}
        closeOnOutsidePress={false}
        footer={
          <>
            <Button onClick={onDismiss} variant="ghost" color="layer1">
              {t("action.cancel")}
            </Button>
            <Button onClick={onSubmit} loading={loading}>
              {t("action.save")}
            </Button>
          </>
        }
      >
        <Form>
          <HudForm color="layer1" />
        </Form>
      </Drawer>
    </FormProvider>
  );
};

export default EditModal;
